import { defineStore } from 'pinia'
import { ref } from 'vue'
import { config } from '@/const/conf'

export const useSidebarStore = defineStore(
  'sidebar-store',
  () => {
    const sidebar_drawer = ref(config.sidebar_drawer)
    const mini_sidebar = ref(config.mini_sidebar)

    /**
     * Toggle main sidebar (open/close)
     */
    function toggleSidebarDrawer() {
      sidebar_drawer.value = !sidebar_drawer.value
    }

    /**
     * Explicit set sidebar drawer
     * @param {boolean} payload
     */
    function setSidebarDrawer(payload) {
      sidebar_drawer.value = payload
    }

    /**
     * Toggle mini sidebar mode
     */
    function toggleMiniSidebar() {
      mini_sidebar.value = !mini_sidebar.value
    }

    /**
     * Explicit set mini sidebar mode
     * @param {boolean} payload
     */
    function setMiniSidebar(payload) {
      mini_sidebar.value = payload
    }

    return {
      sidebar_drawer,
      mini_sidebar,

      toggleSidebarDrawer,
      setSidebarDrawer,
      toggleMiniSidebar,
      setMiniSidebar,
    }
  },
  {
    persist: {
      key: 'sidebar-store',
      storage: localStorage,
      paths: ['mini_sidebar'],
    },
  }
)
